import React, { Component } from 'react';
import { Container, Row, Col, Form, Button, FormGroup, Input } from 'reactstrap';
import Select from 'react-select';
//import CKEditor from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

//import InputFiles from 'react-input-files';
import { Redirect } from 'react-router-dom';
import Api from '../../config/Api';
import Loadings from '../../components/Loading/LoadingSpiner';
//import Navbar from '../../components/Navbars/DemoNavbar';
import Footer from '../../components/Footers/SimpleFooter';
//import { WS_URL } from '../../config/config';
import Notif from '../../components/Notification/Notif';

export default class EditBerita extends Component {
	constructor(props) {
		super(props);
		if (this.props.location.data) {
			this.state = {
				by: localStorage.getItem('namaAdmin'),
				id: this.props.location.data.id,
				idkec: this.props.location.data.idk,
				idDesa: this.props.location.data.idd,
				tps: this.props.location.data.tps,
				loading: false,
				kecamatans: this.props.location.data.kecamatan,
				desas: this.props.location.data.desa,
				calon1: this.props.location.data.calon1,
				calon2: this.props.location.data.calon2,
				redirect: false,
			};
		} else {
			this.state = {
				redirect: true,
			};
		}
	}

	listKecamatan = async () => {
		await Api.post('options/kecamatan', this.state).then((b) => {
			this.setState({
				kecamatan: b.data.rows,
				loading: false,
			});
		});
	};
	listDesa = async () => {
		await Api.post('options/desa', this.state).then((b) => {
			this.setState({
				desa: b.data.rows,
				loading: false,
			});
		});
	};
	componentDidMount = () => {
		this.listKecamatan();
	};
	selectChange = (e) => {
		this.setState({ [e.name]: e.value });
	};
	onSelectKecamatan = (e) => {
		this.setState({ [e.name]: e.value }, () => {
			this.setState(
				{
					idDesa: undefined,
				},
				() => {
					this.listDesa();
				}
			);
		});
	};

	ganti = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	};
	tambahBerita = async (e) => {
		e.preventDefault(e);
		this.setState({
			loading: true,
		});
		let fd = new FormData();
		fd.append('id', this.state.id);
		fd.append('by', this.state.by);
		fd.append('idk', this.state.idkec);
		fd.append('idd', this.state.idDesa);
		fd.append('tps', this.state.tps);
		fd.append('calon1', this.state.calon1);
		fd.append('calon2', this.state.calon2);

		await Api.post('berita/update', fd).then((res) => {
			let status = res.data;
			this.setState({
				message: status.message,
				indicator: status.indicator,
				icon: status.icon,
				loading: false,
				redirect: true,
			});
		});
		Notif(this.state.indicator, this.state.icon, localStorage.getItem('namaAdmin'), this.state.message);
	};
	render() {
		if (this.state.redirect === true) {
			return <Redirect to="/admin/tambah-data" />;
		}
		const selectStyle = {
			option: (provided, state) => ({
				...provided,
				borderBottom: '1px solid #e9ecef',
				backgroundColor: state.isSelected ? 'lighter' : 'white',
				padding: 10,
				fontSize: '14px',
				color: '#8898aa',
				zIndex: '999 !important',
			}),
			control: () => ({
				border: '1px solid white',
				backgroundColor: 'white',
				padding: 2,
				display: 'flex',
				borderRadius: '4px',
			}),

			singleValue: () => ({
				fontSize: '14px',
				color: '#8898aa',
			}),
			placeholder: () => ({
				fontSize: '14px',
				color: '#8898aa',
			}),
		};

		return (
			<>
				{/* <Navbar /> */}
				<Loadings loading={this.state.loading} />
				<main>
					<section className="section pb-3 bg-gradient-primary">
						<Container>
							<Row className="row-grid align-items-center">
								<Col className="order-lg-2 ml-lg-auto pt-5" md="6">
									<div className="position-relative pl-md-5">
										<img
											alt="..."
											className="img-center img-fluid"
											src={require('assets/img/ill/newspaper.png')}
										/>
									</div>
								</Col>
								<Col className="order-lg-1" lg="6">
									<div className="d-flex px-3">
										<div>
											<div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
												<i className="fa fa-pencil text-primary" />
											</div>
										</div>
										<div className="pl-4">
											<h5 className="display-4 text-white">Edit Berita</h5>
											<p className="text-white">
												Halaman ini digunakan untuk mengedit berita. Silahkan Edit Berita
												dibawah.
											</p>
										</div>
									</div>
								</Col>
							</Row>
							<Form onSubmit={this.tambahBerita}>
								<Row className="mt-4">
									<Col md="5">
										<FormGroup className="mb-3">
											<Select
												options={this.state.kecamatan}
												placeholder={this.state.kecamatans}
												styles={selectStyle}
												className="input-group-alternative"
												onChange={this.onSelectKecamatan}
											/>
										</FormGroup>
									</Col>
									<Col md="5">
										<FormGroup className="mb-3">
											<Select
												options={this.state.desa}
												placeholder={this.state.desas}
												styles={selectStyle}
												className="input-group-alternative"
												onChange={this.selectChange}
											/>
										</FormGroup>
									</Col>
									<Col md="2">
										<FormGroup>
											<Input
												placeholder="TPS"
												type="Number"
												name="tps"
												value={this.state.tps}
												onChange={this.ganti}
											/>
										</FormGroup>
									</Col>
									<Col md="6">
										<FormGroup>
											<Input
												placeholder="Paslon Nomor Urut 1"
												type="Number"
												name="calon1"
												value={this.state.calon1}
												onChange={this.ganti}
											/>
										</FormGroup>
									</Col>
									<Col md="6">
										<FormGroup>
											<Input
												placeholder="Paslon Nomor Urut 2"
												type="Number"
												name="calon2"
												value={this.state.calon2}
												onChange={this.ganti}
											/>
										</FormGroup>
									</Col>
								</Row>
								<Button color="default" type="submit" size="sm" className="mt-2" block>
									<i className="fa fa-send fa-2x"></i>
								</Button>
							</Form>
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
						</Container>
					</section>
				</main>
				<Footer />
			</>
		);
	}
}
